/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultsInner1 } from './ResultsInner1';
import {
    ResultsInner1FromJSON,
    ResultsInner1FromJSONTyped,
    ResultsInner1ToJSON,
} from './ResultsInner1';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityAssetsResponse
 */
export interface MonitPaginatedEntityAssetsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityAssetsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ResultsInner1>}
     * @memberof MonitPaginatedEntityAssetsResponse
     */
    results?: Array<ResultsInner1>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitPaginatedEntityAssetsResponse
     */
    available_filters?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MonitPaginatedEntityAssetsResponse interface.
 */
export function instanceOfMonitPaginatedEntityAssetsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityAssetsResponseFromJSON(json: any): MonitPaginatedEntityAssetsResponse {
    return MonitPaginatedEntityAssetsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityAssetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityAssetsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ResultsInner1FromJSON)),
        'available_filters': !exists(json, 'available_filters') ? undefined : json['available_filters'],
    };
}

export function MonitPaginatedEntityAssetsResponseToJSON(value?: MonitPaginatedEntityAssetsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ResultsInner1ToJSON)),
        'available_filters': value.available_filters,
    };
}

